// eslint-disable-next-line import/prefer-default-export
export enum ActionTypes {
  SET_ADVANCED_SEARCH_VALUE = 'SET_ADVANCED_SEARCH_VALUE',
  SET_SECTION_ID = 'SET_SECTION_ID',
  SET_OKPD2 = 'SET_OKPD2',
  SET_REGION = 'SET_REGION',
  SET_RADIUS = 'SET_RADIUS',
  SET_MSP = 'SET_MSP',
  SET_RPN = 'SET_RPN',
  SET_CORT = 'SET_SORT',
  CLEAR = 'CLEAR',
  SET_COUNTERPARTY_SEARCH_RESULT = 'SET_COUNTERPARTY_SEARCH_RESULT',
  SET_COUNTERPARTY_SEARCH_VALUE = 'SET_COUNTERPARTY_SEARCH_VALUE',
  SET_COUNTERPARTY_ERRORS = 'SET_COUNTERPARTY_ERRORS',
  SET_ETP_REGISTRATION_INN = 'SET_ETP_REGISTRATION_INN',
  SET_ETP_REGISTRATION_SEARCH_RESULT = 'SET_ETP_REGISTRATION_SEARCH_RESULT',
  SET_ETP_REGISTRATION_LOADING = 'SET_ETP_REGISTRATION_LOADING',
  SET_ETP_REGISTRATION_ERRORS = 'SET_ETP_REGISTRATION_ERRORS',
  SET_PURCHASING_HISTORY = 'SET_PURCHASING_HISTORY',
  SET_PURCHASING_HISTORY_TAGS = 'SET_PURCHASING_HISTORY_TAGS',
  SET_PURCHASING_HISTORY_LOADING = 'SET_PURCHASING_HISTORY_LOADING',
  SET_PURCHASING_HISTORY_INN = 'SET_PURCHASING_HISTORY_INN',
  SET_PURCHASING_HISTORY_ERRORS = 'SET_PURCHASING_HISTORY_ERRORS',
  SET_PURCHASE_HISTORY_COMPLAINTS = 'SET_PURCHASE_HISTORY_COMPLAINTS',
  SET_PURCHASE_HISTORY_CONTRACTS_AGGREGATES = 'SET_PURCHASE_HISTORY_CONTRACTS_AGGREGATES',
  SET_SUPPLIERS = 'SET_SUPPLIERS',
  SET_SUPPLIERS_PAGE = 'SET_SUPPLIERS_PAGE',
  SET_SUPPLIERS_SEARCH_ID = 'SET_SUPPLIERS_SEARCH_ID',
  SET_SUPPLIERS_SEARCH_ERRORS = 'SET_SUPPLIERS_SEARCH_ERRORS',
  SET_AUTH = 'SET_AUTH',
  SET_USER_DATA = 'SET_USER_DATA',
  SET_LIMIT = 'SET_LIMIT',
  SET_SORT_PARTICIPATION = 'SET_SORT_PARTICIPATION',
  SET_SORT_VICTORIES = 'SET_SORT_VICTORIES',
  SET_SIZE_SIDEBAR = 'SET_SIZE_SIDEBAR',
  // new
  SET_OKPD2_DATA = 'SET_OKPD2_DATA',
  SEARCH_OKPD2_DATA = 'SEARCH_OKPD2_DATA',
  SET_PROCEDURE_BIDS_COUNT_FOR_BUYER = 'SET_PROCEDURE_BIDS_COUNT_FOR_BUYER',
  SET_BIDS_REGION_PROCEDURE_BIDS_COUNT = 'SET_BIDS_REGION_PROCEDURE_BIDS_COUNT',
  SET_TAGS_PROCEDURE_BIDS_COUNT = 'SET_TAGS_PROCEDURE_BIDS_COUNT',
  SET_OKPD2_WON_PROCEDURE_BIDS_COUNT = 'SET_OKPD2_WON_PROCEDURE_BIDS_COUNT',
  SET_LINKED_BUYER_DESCRIPTION = 'SET_LINKED_BUYER_DESCRIPTION',
  SET_REGIONS_BY_INN = 'SET_REGIONS_BY_INN',
  SET_BIDS_REGIONS = 'SET_BIDS_REGIONS',
}
